export default __webpack_public_path__ + "static/pqrs-b05fbccad651ca8b6c72f9ed7aa4c5b0.png";